<template>
  <div class="input-box">
    <div class="input-with-icon">
      <input
        :type="type"
        class="search-input"
        :placeholder="placeholder"
        :value="value"
        @input="handleInput"
        v-bind:class="{ error: isError }"
        :minlength="minlength"
        :maxlength="maxlength"
        :style="{ padding: inputPadding }"
      />
      <img
        v-if="!hideImg"
        src="@/assets/img/search.svg"
        alt="search"
        class="search-icon"
      />
    </div>
    <p v-if="isError" class="error-message">{{ errorMessage }}</p>
  </div>
</template>
<script>
export default {
  name: "InputCustomWithImg",
  props: {
    type: {
      type: String,
      default: "text",
    },
    className: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    minlength: {
      type: Number,
      default: 3,
    },
    maxlength: {
      type: Number,
      default: 30,
    },
    errorMessage: {
      type: String,
      default: "Error",
    },
    hideImg: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputPadding() {
      return this.$props.hideImg ? "12px 20px" : "12px 20px 12px 60px";
    },
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
};
</script>

<style scoped>
.input-box {
  position: relative;
  width: 100%;
}
.input-with-icon {
  position: relative;
  width: 100%;
  display: inline-block;
}
.search-input {
  border-radius: 6px;
  border: 1px solid #d1d1d6;
  width: 100%;
  height: 46px;
  color: #828F9A;
  font-size: 17px;
  line-height: 22px;
}
.search-input::placeholder {
  color: #828F9A;
  font-size: 17px;
  line-height: 22px;
}

.error {
  border-color: red;
}

.error-message {
  position: absolute;
  top: 54px;
  left: 0;
  color: red;
}

.search-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  color: #828f9a;
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.17px;
}
</style>
